/**
 * @generated SignedSource<<840c1a6af381621bbd918ab09596191e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Redeem_receipt$data = {
  readonly transactionFee: {
    readonly symbol: string;
    readonly unit: string;
    readonly usd: string;
  };
  readonly " $fragmentType": "Redeem_receipt";
};
export type Redeem_receipt$key = {
  readonly " $data"?: Redeem_receipt$data;
  readonly " $fragmentSpreads": FragmentRefs<"Redeem_receipt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Redeem_receipt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceType",
      "kind": "LinkedField",
      "name": "transactionFee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usd",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionReceiptType",
  "abstractKey": null
};

(node as any).hash = "6eead9a484fc89e1ae93f438bf29d94d";

export default node;
